import { motion } from "framer-motion";
import { useMemo } from "react";

interface Particle {
  id: number;
  tx: number;
  ty: number;
  rotate: number;
  delay: number;
  duration: number;
  size: number;
}

const PARTICLE_COUNT = 42;

export function CoinBurst() {
  const particles = useMemo(() => {
    const result: Particle[] = [];
    for (let i = 0; i < PARTICLE_COUNT; i++) {
      const angle =
        (i / PARTICLE_COUNT) * 2 * Math.PI + (Math.random() - 0.5) * 0.28;
      const distance = 90 + Math.random() * 230;
      result.push({
        id: i,
        tx: Math.cos(angle) * distance,
        ty: Math.sin(angle) * distance,
        rotate: Math.random() * 760,
        delay: Math.random() * 0.12,
        duration: 0.65 + Math.random() * 0.25,
        size: 24 + Math.random() * 12,
      });
    }
    return result;
  }, []);

  return (
    <div className="absolute inset-0 flex items-center justify-center overflow-hidden">
      {/* Central flash */}
      <motion.div
        className="absolute"
        style={{
          left: "50%",
          top: "50%",
          width: 150,
          height: 150,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(250,204,21,0.65) 0%, rgba(168,85,247,0.22) 70%, rgba(168,85,247,0) 100%)",
          x: -75,
          y: -75,
          willChange: "transform, opacity",
        }}
        initial={{ scale: 0, opacity: 1 }}
        animate={{ scale: 2.4, opacity: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      />

      {/* Particles */}
      {particles.map((p, idx) => (
        <motion.div
          key={p.id}
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            width: p.size,
            height: p.size,
            marginLeft: -p.size / 2,
            marginTop: -p.size / 2,
            willChange: "transform, opacity",
            backfaceVisibility: "hidden",
          }}
          initial={{
            x: -p.size / 2,
            y: -p.size / 2,
            scale: 1.5,
            opacity: 1,
          }}
          animate={{
            x: p.tx - p.size / 2,
            y: p.ty - p.size / 2,
            scale: 0,
            opacity: 0,
            rotate: p.rotate,
          }}
          transition={{
            duration: p.duration,
            delay: p.delay,
            ease: "easeOut",
          }}
        >
          <img
            src="/espont.png"
            alt="coin"
            className="w-full h-full object-contain"
            draggable={false}
          />
        </motion.div>
      ))}
    </div>
  );
}
